"use client";

import React from "react";
import "./MessageSkeleton.css";

interface MessageSkeletonProps {
  variant?: "text" | "image" | "video" | "audio" | "file";
  isOwn?: boolean;
}

const MessageSkeleton: React.FC<MessageSkeletonProps> = ({ variant = "text", isOwn = false }) => {
  return (
    <div className={`message-skeleton ${isOwn ? "own" : "received"}`}>
      <div className="bubble-skeleton">
        {/* خط‌های متن */}
        {(variant === "text" || variant === "file") && (
          <>
            <div className="line w-80" />
            <div className="line w-60" />
            <div className="line w-40" />
          </>
        )}

        {/* تصویر، ویدیو یا فایل */}
        {(variant === "image" || variant === "video" || variant === "file") && (
          <div className="media-skeleton" />
        )}

        {/* صوت */}
        {variant === "audio" && (
          <div className="audio-skeleton">
            <div className="circle" />
            <div className="bar" />
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageSkeleton;
